import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { CustomersView } from './components/CustomersView';

import { Button } from '@/components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { ROUTE_PATHS } from '@/config/constants';

export function AdminCustomers() {
  const navigate = useNavigate();

  function handleCustomersClick() {
    navigate(ROUTE_PATHS.ADMIN_CUSTOMERS_CREATE);
  }
  return (
    <div style={{ minHeight: '100vh' }}>
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-4xl font-bold">Customers</h1>
        <Button onClick={handleCustomersClick}>
          {' '}
          <Plus className="mr-2 h-4 w-4" /> Create New Customer{' '}
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>All Customers</CardTitle>
        </CardHeader>
        <CardContent>
          <CustomersView />
        </CardContent>
      </Card>
    </div>
  );
}
